<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tscheduledetail}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="">
          <wPickers v-model="dateValue" @input="getTimes"></wPickers>
        </el-form-item>
        <el-form-item>
          <renSelect
            v-model="dataForm.product"
            dictType="loan_type"
            originPage="put"
            placeholder="产品"
          ></renSelect>
        </el-form-item>
        <el-form-item>
          <wList v-model="dataForm.companyId"  type="1" placeholder="公司名称"></wList>
        </el-form-item>
        <el-form-item>
          <wCity v-model="dataForm.city" defaultUrl="/sys/tscheduledetail/accessToAccess" placeholder="城市"></wCity>
        </el-form-item>
       
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:tscheduledetail:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tscheduledetail:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>                                              -->
      </el-form>    
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"   @sort-change="dataListSortChangeHandle($event,false)" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <!-- <el-table-column prop="id" label="主键id" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="companyName" label="公司" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品" header-align="center" align="center"></el-table-column>
        <el-table-column prop="city" label="城市"  header-align="center" align="center"  sortable="custom" ></el-table-column>
        <el-table-column prop="price" label="定价(元/个)"  header-align="center" align="center"  sortable="custom" ></el-table-column>
        
        <el-table-column prop="dates" label="投放日期" sortable="custom"  header-align="center" align="center">
          <template slot-scope="scope">
          <div>
            {{scope.row.dates.split(' ')[0]}}
          </div>
        </template>
        </el-table-column>
        <el-table-column prop="detailedTime" label="投放时间段"   header-align="center" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.cycle+': '+scope.row.detailedTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="线索数量" sortable="custom"  header-align="center" align="center"></el-table-column>
        <el-table-column prop="lockThread" label="锁定数量" sortable="custom"  header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="录入时间" sortable="custom"  header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="修改时间" sortable="custom"  header-align="center" align="center"></el-table-column>
      
        <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:tscheduledetail:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:tscheduledetail:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tscheduledetail-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/tscheduledetail/page',
        getDataListIsPage: true,
        exportURL: '/sys/tscheduledetail/export',
        deleteURL: '/sys/tscheduledetail',
        deleteIsBatch: true
      },
      dateValue: '',
      dataForm: {
        id: '',
       
        product: '',
        startDate: '',
        endDate: '',
        companyId: '',
        city: '',
      }
    }
  },
  methods: {
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0];
        this.dataForm.endDate = this.dateValue[1];
      } else {
        delete this.dataForm.startDate 
        delete this.dataForm.endDate
      }
    },
   
  },
  components: {
    AddOrUpdate
  }
}
</script>
